/**
 * @author vishwadeep.kapoor
 * @Date: 2018-08-23 15:05:41
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-26 16:30:08
 */
import React, { Fragment, Component } from 'react';
import { differenceBy } from 'lodash'; // TODO:: can be moved to utils
import StyledBooking from './StyledBooking';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Quantity from '../../components/Quantity';
import ValidationErrors from '../../components/ValidationErrors';
import { utils } from '../../devUtils';
import endPoints from '../../config/endPoints';
import { BookingDefaultProps, BookingProps } from './giftCardProductDataHandler';

const free_message = 'Free field value must be in between :min and :max';

class Booking extends Component {
  constructor(props) {
    super(props);
    const { variations, voucherType, default_select, defaultVariationType } = props;
    this.state = {
      selectedVariations: (voucherType === 'merchandise' && !default_select) ? [] : variations,
      variationType: defaultVariationType || [],
      isShowContactUs: false,
    };
    this.handleVariationType = this.handleVariationType.bind(this);
    this.handleContactForm = this.handleContactForm.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { variations, GiftCardContact, GiftCardContact: { status }, voucherType } = nextProps;
    const { variations: _variations, GiftCardContact: _GiftCardContact } = this.props;
    if (!utils.isEqual(variations, _variations)) {
      const { selectedVariations } = this.state;
      const { id } = utils.lodashFind(variations, { active: true }) || {};
      const _selectedVariations = voucherType === 'merchandise' ?
        selectedVariations.map((item) => {
          const _item = { ...item };
          if (item.id === id) {
            _item.active = true;
          } else {
            _item.active = false;
          }
          return _item;
        }) : variations;
      this.setState({ selectedVariations: _selectedVariations });
    } else if (!utils.isEqual(GiftCardContact, _GiftCardContact) && status) {
      this.setState({ isShowContactUs: false });
    }
  }

  handleContactForm(type, evt) {
    const { onSetProductContactUs } = this.props;
    const { isShowContactUs } = this.state;
    switch (type) {
      case 'VISIBILITY':
        this.setState({ isShowContactUs: !isShowContactUs });
        break;
      case 'FORM_SUBMIT': {
        evt.preventDefault();
        const payload = {};
        [
          'name',
          'email',
          'mobile',
          'company',
          'product_name',
          'quantity',
        ].forEach((item) => {
          payload[item] = evt.target[item].value;
        });
        onSetProductContactUs(payload);
      }
        break;
      default:
        break;
    }
  }

  handleVariationType(name, value) {
    const { variations, handleChildActions } = this.props;
    const { variationType } = this.state;
    const isVariationActive = variationType.findIndex(({ name: iName }) => (iName === name));
    if (isVariationActive === -1) {
      variationType.push({ name, value });
    } else {
      variationType[isVariationActive].value = value;
    }
    const _selectedVariations = [];
    variations.forEach((item) => {
      const { variation_types } = item;
      const diffValueAry = differenceBy(variation_types, variationType, 'value');
      // const diffNameAry = differenceBy(variationType, variation_types, 'name');
      if (!diffValueAry.length) { //  && !diffNameAry.length
        _selectedVariations.push(item);
      }
    });
    this.setState({ selectedVariations: _selectedVariations, msgOnload: true }, () => {
      if (_selectedVariations && _selectedVariations.length) {
        handleChildActions('variation', _selectedVariations[0].value, _selectedVariations[0].id, true);
      } else {
        handleChildActions('variation', '', '', true);
      }
    });
  }

  // renderRecipientDetails() {
  //   const { voucherType, email, handleChildActions, _childUpdateValidators, isShowValidation, validators, phone } = this.props;
  //   return (voucherType && voucherType === 'evoucher') ?
  //     <div className="recipient_details">
  //       <h2>Recipient Details</h2>
  //       <Input
  //         placeholder="Email"
  //         value={email}
  //         onChange={(e) => {
  //           handleChildActions('updateEmail', e.target.value);
  //           _childUpdateValidators('email', e.target.value);
  //         }}
  //         required
  //         type="email"
  //       />
  //       {isShowValidation && ValidationErrors(validators, 'email')}
  //       <Input
  //         placeholder="Phone"
  //         value={phone}
  //         onChange={(e) => {
  //           handleChildActions('updateMobile', e.target.value);
  //           _childUpdateValidators('phone', e.target.value);
  //         }}
  //         required
  //         maxLength={10}
  //         type="text"
  //       />
  //       {isShowValidation && ValidationErrors(validators, 'phone')}
  //     </div> : '';
  // }

  renderVariationType() {
    const { variation_types } = this.props;
    return variation_types.map(({ name, values }, index) => (
      <div style={{ fontSize: '16px', marginBottom: '10px' }} key={[index]}>
        <span style={{ width: '50%' }}>Select {name}: </span>
        <select
          onChange={({ target }) => this.handleVariationType(name, target.value)}
          style={{ width: '50%', marginLeft: '5px' }}
          className="pull-right"
          defaultValue={values && values.length === 1 ? values[0] : ''}
        >
          <option value="">Select one {name}</option>
          {values.map((item, sIndex) => <option key={[sIndex]} value={item}>{item}</option>)}
        </select>
      </div>
    ));
  }

  renderBankCardsDetails(variationValue, serviceFee, price) {
    return (
      <table className="lg-none">
        <tbody>
          <tr>
            <th>Value</th>
            <th>Service Fee</th>
            <th>Price</th>
          </tr>
          <tr>
            <td>&#8377;&nbsp;{variationValue}</td>
            <td>&#8377;&nbsp;{serviceFee}</td>
            <td>&#8377;&nbsp;{price}</td>
          </tr>
        </tbody>
      </table>);
  }

  renderContactUsForm() {
    const { isShowContactUs } = this.state;
    return isShowContactUs ? (
      <Fragment>
        <br clear="all" />
        <form onSubmit={(evt) => this.handleContactForm('FORM_SUBMIT', evt)}>
          <Input name="name" required placeholder="Name" style={{ width: '100%' }} />
          <Input name="email" required type="email" placeholder="Email" style={{ width: '100%' }} />
          <Input name="mobile" required type="number" placeholder="Mobile Number" style={{ width: '100%' }} />
          <Input name="company" required placeholder="Company" style={{ width: '100%' }} />
          <Input name="product_name" required placeholder="Product Name" style={{ width: '100%' }} />
          <Input name="quantity" required type="number" placeholder="Quantity" style={{ width: '100%' }} min="200" /><br />
          <Button type="submit" style={{ marginTop: '20px' }}>Submit</Button>
        </form>
      </Fragment>
    ) :
      <Fragment>
        <div style={{ fontSize: '16px', marginBottom: '10px', lineHeight: 'normal' }}>More then 200 units? Speak to us to get our best quote</div>
        <br clear="all" /><Button type="primary" onClick={() => this.handleContactForm('VISIBILITY')}>Contact Us</Button>
      </Fragment>;
  }

  render() {
    const { voucherType, handleChildActions,
      isBankCard,
      quantity,
      // cardData: { discounts_percent }, clientid, // variations
      variationObj: { variationValue, price },
      visibility,
      isShowValidation,
      _childUpdateValidators,
      validators,
      client_series,
    } = this.props;
    const { selectedVariations } = this.state;
    let giftCardValue = variationValue;
    // let result = (parseFloat(giftCardValue) * parseFloat(discounts_percent && discounts_percent.payment_gateway)) / 100;
    // let savedPrice = parseFloat(giftCardValue) - result;
    // const discountPersent = discounts_percent && discounts_percent.payment_gateway && parseFloat(discounts_percent.payment_gateway) > 0;
    const serviceFee = giftCardValue - price;
    if (quantity > 1) {
      // result *= quantity;
      // savedPrice *= quantity;
      giftCardValue *= quantity;
    }
    return (
      <StyledBooking>
        <div className="padding-20">
          <h2>Choose Value</h2>
          {voucherType === 'merchandise' ? this.renderVariationType() : null}
          <ul className="value">
            {selectedVariations && selectedVariations.length ? selectedVariations.map((variation) => {
              const { active, id, name, key, free_field, min_free_field_value, max_free_field_value, value } = variation;
              return (
                <li key={key}>{
                  free_field ?
                    <strong className={active ? 'active' : ''} data-value={value} role="presentation">
                      <Input
                        placeholder="Amount Of Your Choice"
                        type="text"
                        onChange={(e) => {
                          handleChildActions('variation', e.target.value, id, true);
                          _childUpdateValidators('range', e.target.value, {
                            min: min_free_field_value,
                            max: max_free_field_value,
                            message: free_message,
                          });
                        }}
                      />
                      {isShowValidation && active && ValidationErrors(validators, 'range')}
                    </strong> :
                    <strong
                      className={active ? 'active' : ''}
                      data-value={value}
                      onClick={() => {
                        handleChildActions('variation', value, id, true);
                      }}
                      role="presentation"
                    >
                      <span className="pointer-none">
                        {voucherType !== 'merchandise' ? <Fragment>&#8377;&nbsp;</Fragment> : <Fragment>&nbsp;</Fragment>}
                      </span>
                      <span className="pointer-none hand-cursor">
                        {name}
                      </span>
                    </strong>
                }
                </li>
              );
            }) : <span>--Select variation combination--</span>}
          </ul>
          {/* <Input placeholder="Enter Amount of your choice" /> */}
          <h2 className="margin-t-2">Quantity</h2>
          <Quantity {...this.props} />
          <br clear="all" />

          {/* here this content need to show only on mobile */}
          {/* <div className="price lg-none">
            <h2>Total</h2>
            {clientid === 'payment_gateway' && discountPersent ? (
              <span>
                <span>&#8377;&nbsp;{savedPrice}</span> <strike>&#8377;&nbsp;{giftCardValue}</strike> <b>(You Save:&#8377;&nbsp;{result})</b>
              </span>) : (<span>&#8377;&nbsp;{giftCardValue}</span>)}
            <hr />
          </div> */}
          {isBankCard && this.renderBankCardsDetails(variationValue, serviceFee, price)}
          {/* ends here */}
          {/* {this.renderRecipientDetails()} */}
          {visibility ? (
            <div className="footer">
              {/* <Button onClick={() => handleChildActions('addToCart')} disabled={!selectedVariations.length}>Add to Cart</Button> */}
                &nbsp;&nbsp;&nbsp;
              {/* <Button type="primary" onClick={() => handleChildActions('buyNow')} disabled={!selectedVariations.length}>Buy Now</Button> */}
            </div>
          ) : (<div className="footer">This Product is currently not available for purchase</div>)}
          {(voucherType === 'merchandise' && (client_series !== endPoints.PROPEL_CORPORATE_GIFTING)) ? this.renderContactUsForm() : null}
          {/* <div className="bottom">
            Want to place a <strong>Bulk Order? </strong> <a href="#/">Contact us</a>
          </div> */}
        </div>
      </StyledBooking>
    );
  }
}

Booking.defaultProps = BookingDefaultProps;
Booking.propTypes = BookingProps;

export default Booking;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/Booking.js